module.exports = __webpack_public_path__ + "static/media/polytunnels-at-sussex.crop.9046fa6d.jpg";